import React from 'react'
import Chart from './Chart'

function FinancialBreakdown(props) {
  const {
    loanDetail: { financialGraph },
  } = props

  const { incomeTitle } = financialGraph

  return (
    <div className='card card-single'>
      <div className='card-header'>
        Your financials
      </div>
      <div className='card-body'>
        <div className='big'>
          With <strong>gross income of { incomeTitle }</strong>, here is a high level breakdown of your financial situation once you start repaying your loan based on the information you have provided.

          <Chart financialGraph={ financialGraph } />
        </div>
      </div>
    </div>
  )
}

export default FinancialBreakdown
